import { Observable } from 'rxjs';
import 'rxjs/add/operator/delay';
import 'rxjs/add/observable/of';

export class DataStep1
{

    public static departaments = [
        {
            id: 1,
            name: 'Lima',
        }
    ];
    public static districts = [
        {
            id: 1,
            name: 'Ancón',
        },
        {
            id: 2,
            name: 'Ate',
        },
        {
            id: 3,
            name: 'Barranco',
        },
        {
            id: 4,
            name: 'Breña',
        },
        {
            id: 5,
            name: 'Carabayllo',
        },
        {
            id: 6,
            name: 'Chaclacayo',
        },
        {
            id: 7,
            name: 'Chorrillos',
        },
        {
            id: 8,
            name: 'Cieneguilla',
        },
        {
            id: 9,
            name: 'Comas',
        },
        {
            id: 10,
            name: 'El Agustino',
        },
        {
            id: 11,
            name: 'Huaycán',
        },
        {
            id: 12,
            name: 'Independencia',
        },
        {
            id: 13,
            name: 'Jesús María',
        },
        {
            id: 14,
            name: 'La Molina',
        },
        {
            id: 15,
            name: 'La Victoria',
        },
        {
            id: 16,
            name: 'Lima',
        },
        {
            id: 17,
            name: 'Lince',
        },
        {
            id: 18,
            name: 'Los Olivos',
        },
        {
            id: 19,
            name: 'Lurigancho',
        },
        {
            id: 20,
            name: 'Lurín',
        },
        {
            id: 21,
            name: 'Magdalena del Mar',
        },
        {
            id: 22,
            name: 'Miraflores',
        },
        {
            id: 23,
            name: 'Pachacamac',
        },
        {
            id: 24,
            name: 'Pucusana',
        },
        {
            id: 25,
            name: 'Pueblo Libre',
        },
        {
            id: 26,
            name: 'Puente Piedra',
        },

        {
            id: 27,
            name: 'Punta Hermosa',
        },
        {
            id: 28,
            name: 'Punta Negra',
        },
        {
            id: 29,
            name: 'Rímac',
        },
        {
            id: 30,
            name: 'San Bartolo',
        },
        {
            id: 31,
            name: 'San Borja',
        },
        {
            id: 32,
            name: 'San Isidro',
        },
        {
            id: 33,
            name: 'San Juan de Lurigancho',
        },
        {
            id: 34,
            name: 'San Juan de Miraflores',
        },
        {
            id: 35,
            name: 'San Luis',
        },
        {
            id: 36,
            name: 'San Martín de Porres',
        },
        {
            id: 37,
            name: 'San Miguel',
        },
        {
            id: 38,
            name: 'Santa Anita',
        },
        {
            id: 39,
            name: 'Santa María del Mar',
        },
        {
            id: 40,
            name: 'Santa Rosa',
        },
        {
            id: 41,
            name: 'Surquillo',
        },
        {
            id: 42,
            name: 'Villa El Salvador',
        },
        {
            id: 43,
            name: 'Villa María del Triunfo',
        },
    ];


}
